import { atom } from "recoil";
import { IEmailIRoute } from "../generated/Api";
import { IEmail } from "../types/EmailTypes";
import { EmailReport } from "./EmailReportAtom";

interface IEmailFilterCounter {
  byLabelCount: number;
  byStatusCount: number;
  byScheduledDate: number;
}

export const AllEmailsAtom = atom<
  (IEmailIRoute & {
    reportInfo?: {
      summary: EmailReport;
      summaryA?: EmailReport;
      summaryB?: EmailReport;
    };
  })[]
>({
  key: "AllEmailsAtom",
  default: [],
});

export const AllEmailsCountAtom = atom<number | null>({
  key: "AllEmailsCountAtom",
  default: null,
});

export enum AllEmailsViews {
  STATUS = "STATUS",
  CALENDAR = "CALENDAR",
  REPO = "REPO",
  DEFAULT = "DEFAULT",
}

export const AllEmailsViewsAtom = atom<AllEmailsViews>({
  key: "AllEmailsViewsAtom",
  default: AllEmailsViews.DEFAULT,
});

export const HighlightsSearchEmailAtom = atom<string[]>({
  key: "HighlightsSearchEmailAtom",
  default: [],
});

export const LoadingEmailsAtom = atom<boolean>({
  key: "LoadingEmailsAtom",
  default: false,
});

export const EmailFilterCounterAtom = atom<IEmailFilterCounter>({
  key: "emailFilterCounterAtom",
  default: {
    byLabelCount: 0,
    byStatusCount: 0,
    byScheduledDate: 0,
  },
});

export const ShowEmailFilter = atom<boolean>({
  key: "ShowEmailFilterAtom",
  default: false,
});
